import axios from "axios";
import { SERVICEURL } from "../appconfig";

/**
 * Canli mulakat soketi icin Wiser BE'den tek kullanimlik stream ticket'i alir (#12388).
 * Tarayici WebSocket API'si Authorization basligi gonderemedigi icin oturum token'i
 * bu REST cagrisinda kullanilir; soket ise ticket ile acilir. Ticket 60 sn gecerlidir.
 */
export const getIcsStreamTicket = async (interviewId: string): Promise<string> => {
  const token = localStorage.getItem("token");
  const response = await axios.post(
    `${SERVICEURL}api/ics/interviews/${interviewId}/stream-ticket`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const ticket = response.data?.data?.ticket ?? response.data?.ticket;
  if (typeof ticket !== "string" || ticket.length === 0) {
    throw new Error("Stream ticket yanitta yok.");
  }
  return ticket;
};
